import { render, staticRenderFns } from "./delivery-appointment.vue?vue&type=template&id=2567490a&scoped=true&"
import script from "./delivery-appointment.vue?vue&type=script&lang=js&"
export * from "./delivery-appointment.vue?vue&type=script&lang=js&"
import style0 from "./delivery-appointment.vue?vue&type=style&index=0&id=2567490a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2567490a",
  null
  
)

component.options.__file = "delivery-appointment.vue"
export default component.exports